import React from 'react';
import { Link } from 'react-router-dom';
import { APP_NAME } from '../../config/index.js';
import { routeForSlug } from '../../layouts/menuData.js';
import { useAuth } from '../../context/AuthContext.jsx';

/** Shared, themed status page (401 / 403 / 404 / 500) using theme tokens + app branding. */
export default function StatusPage({ code, title, message, icon, showLogin }) {
  const { isAuthenticated } = useAuth();
  return (
    <div className="d-flex align-items-center justify-content-center px-3" style={{ minHeight: '100vh', background: 'var(--bg-color)' }}>
      <div className="card text-center p-4 p-md-5" style={{ maxWidth: 480, width: '100%' }}>
        <div className="mb-3">
          <i className="fas fa-clipboard-check me-2" style={{ color: 'var(--color-secondary)' }} aria-hidden="true"></i>
          <span className="fw-bold" style={{ color: 'var(--color-primary)' }}>{APP_NAME}</span>
        </div>
        <i className={icon + ' mb-3'} style={{ fontSize: '2.5rem', color: 'var(--color-secondary)' }} aria-hidden="true"></i>
        <h1 className="display-4 fw-bold mb-1">{code}</h1>
        <h2 className="h5 mb-3">{title}</h2>
        <p className="text-muted mb-4">{message}</p>
        <div className="d-flex gap-2 justify-content-center flex-wrap">
          <Link className="btn btn-primary" to="/">
            <i className="fas fa-home me-1" aria-hidden="true"></i> Back to home
          </Link>
          {showLogin && !isAuthenticated && (
            <Link className="btn btn-outline-secondary" to={routeForSlug('sign-in')}>
              <i className="fas fa-sign-in-alt me-1" aria-hidden="true"></i> Sign in
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
